export { CortexChatPanel } from './chat.tsx';

/** Its pages and views the host (or another module) loads when shown. */
export const pages = {
  'admin/AiSettingsCards': () => import('./admin/AiSettingsCards.tsx'),
  'admin/AiToolPolicyCard': () => import('./admin/AiToolPolicyCard.tsx'),
  'admin/ConnectGuide': () => import('./admin/ConnectGuide.tsx'),
  chat: () => import('./chat.tsx'),
  'pages/AiGatewayPage': () => import('./pages/AiGatewayPage.tsx'),
  'pages/ProjectAiPage': () => import('./pages/ProjectAiPage.tsx'),
};
